import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { ProviderInput } from '@/lib/api/domains/providers';
import { keys } from '@/lib/query-keys';

export function useCreateProvider() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ProviderInput) => api.providers.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.providers.lists() });
    },
  });
}
